/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { MediaObject } from "../basic/media-object-list.js";
import { CollectionName } from "../atoms/collection-name/index.js";
import { AdService } from "../ad-service";
import { updateStoriesWithAlternatives } from "../../utils";

function FullscreenStoryList(props) {
  if (props.stories.length < 1) return <div />;
  const stories = updateStoriesWithAlternatives(props.stories, false);
  const mediaObjectConfig = {
    section: !props.hideSectionName,
    enlarged: true,
    noBackground: true,
    storyTime: true,
    aspectRatio: [5, 3],
    widths: [96, 192, 258],
    sizes: "(max-width: 500px) 96px, (max-width: 768px) 96px, 258px"
  };
  const collectionName = get(props.associatedMetadata, ["show_collection_title"], true);

  return (
    <div className="fullscreen-media-list" data-test-id="fullscreen-story-list-component">
      <div className="fullscreen-media-list__content component-wrapper">
        {collectionName ? (
          <CollectionName
            className="fullscreen-media-list__section-name"
            name={props.config["collection-name"]}
            config={props.config}
            section={props.config["collection-section"] || props.collection}
          />
        ) : null}
        <div className="fullscreen-media-list__stories">
          {stories.map(storyObj => {
            const story = storyObj && storyObj.story ? storyObj.story : storyObj;
            return (
              <div className="fullscreen-media-list__object" key={story.id}>
                <MediaObject story={story} config={mediaObjectConfig} sectionColor={props.config["collection-color"]} />
              </div>
            );
          })}

          {(props.associatedMetadata ? props.associatedMetadata.enable_load_more_button === true : true) &&
            !props.noMoreStories && (
              <div className="load-more">
                <button onClick={props.onLoadMore}>Load More</button>
              </div>
            )}
        </div>
        <div className="ad-container">
          <div className="app-ad app-ad--vertical">
            <AdService adtype="Vertical-Ad" slotId={`FullscreenStoryList-${props.index}`} />
          </div>
        </div>
      </div>
    </div>
  );
}
FullscreenStoryList.propTypes = {
  config: PropTypes.object,
  stories: PropTypes.array,
  hideSectionName: PropTypes.bool,
  collection: PropTypes.object,
  associatedMetadata: PropTypes.object,
  noMoreStories: PropTypes.bool,
  onLoadMore: PropTypes.func,
  index: PropTypes.number
};

export { FullscreenStoryList };
